import Dexie from 'dexie'

import { Component, PersistentDataStorage } from '@hatiolab/things-scene'

class BoardDatabase extends Dexie {
  board_data!: Dexie.Table<IBoardData, number> // number = type of the primkey
  playlist_data!: Dexie.Table<IPlayListData, number> // number = type of the primkey
  //...other tables goes here...

  constructor() {
    super('operato-board-database')
    this.version(2).stores({
      board_data: '[board+refid]',
      playlist_data: '[playlist+dummy]'
      //...other tables goes here...
    })
  }
}

interface IBoardData {
  id?: number
  board: string
  refid: string | number
  data: any
  timestamp: number
}

interface IPlayListData {
  id?: number
  playlist: string
  dummy: string | number // only for escaping schema error
  setting: {
    playtime: number
    columns: number
    rows: number
  }
  timestamp: number
}

const db = new BoardDatabase()

export class BoardDataStorage implements PersistentDataStorage {
  private id: string

  constructor(id: string) {
    this.id = id
  }

  public async load(key: Component): Promise<any> {
    const saved = await db.board_data.where({ board: this.id, refid: key.state.refid }).first()
    return saved?.data
  }

  public async save(key: Component, value: any): Promise<void> {
    await db.board_data.put({ board: this.id, refid: key.state.refid, data: value, timestamp: Date.now() })
  }

  public async clear(key: Component): Promise<void> {
    await db.board_data.where({ board: this.id, refid: key.state.refid }).delete()
  }
}

export class PlaylistStorage implements PersistentDataStorage {
  public async load(key: any): Promise<any> {
    const saved = await db.playlist_data.where({ playlist: key }).first()
    return saved?.setting
  }

  public async save(key: any, value: any): Promise<void> {
    await db.playlist_data.put({ playlist: key, dummy: 1, setting: value, timestamp: Date.now() })
  }

  public async clear(key: any): Promise<void> {
    await db.playlist_data.where({ playlist: key }).delete()
  }
}
